export default "__VITE_ASSET__BRGgDkSY__"